export const sinvoiceViettel = [
  {
    path: '/sinvoice/customer-information',
    component: () => import('@/views/sinvoice_viettel/CustomerInformationScreen.vue')
  },
  {
    path: '/sinvoice/export-by-class',
    component: () => import('@/views/sinvoice_viettel/ExportByClassView.vue')
  },
  {
    path: '/sinvoice/export-by-group',
    component: () => import('@/views/sinvoice_viettel/ExportByGroupView.vue')
  },
  {
    path: '/sinvoice/invoice-management',
    component: () => import('@/components/sinvoice_viettel/InvoiceManagement.vue')
  },
  {
    path: '/sinvoice/invoice-management-other',
    component: () => import('@/components/sinvoice_viettel/InvoiceManagementOther.vue')
  },
  {
    path: '/sinvoice/goods-services',
    component: () => import('@/views/sinvoice_viettel/GoodsServiceManagementView.vue')
  }
];
